export const ActionTypes = {
  UPDATE_ORG_THEME: "UPDATE_ORG_THEME",
  DELETE_ORG_THEME: "DELETE_ORG_THEME",
  SET_ORG_THEME: "SET_ORG_THEME"
}
